module.exports = __webpack_public_path__ + "static/media/lente-pronta-logo.44549362.png";